export const errorMessages = {
  code000: '数字##桁でご入力ください',

  code001: '数字##桁以上でご入力ください',

  code002: '数字##桁以内でご入力ください',

  code003: '数字##桁以上**以内でご入力ください',

  code004: '合計全角##文字でご入力ください',

  code005: '合計全角##文字以上でご入力ください',

  code006: '合計全角##文字以内でご入力ください',

  code007: '##文字以上**以内でご入力ください',

  code008: '必ずご入力ください',

  code009: '必ず2段ともご入力ください',

  code010: 'もう一つご選択ください',

  code011: 'もう一つご入力ください',

  code012: 'あと二つご選択ください',

  code013: 'あと二つご入力ください',

  code014: '必ずご選択ください',

  code015: '##以上の数字をご入力ください',

  code016: '##以下の数字をご入力ください',

  code017: '##以上**以内の数字をご入力ください',

  code018: '全角文字でご入力ください',

  code019: '全角カナでご入力ください',

  code020: '半角数字でご入力ください',

  code021: '小数点以下##桁でご入力ください',

  code022: 'メールアドレスは有効なメールアドレスを入力してください',

  code023: '電話番号の形式でご入力ください',

  code024: '合計全角##文字以内**以内でご入力ください',

  code025: '##文字でご入力ください',

  code026: '##文字以上でご入力ください',

  code027: '##文字以内でご入力ください',

  code028: '半角英数字でご入力ください',

  code029: '必ず一つ以上ご入力ください',

  code030: '半角英字、半角数字、半角記号3種類混在でご入力ください',
  
  code031: '##と一致しません。再度入力してください',

  code032: '##',

  code033: '半角英数記号でご入力ください',

  code034: '8桁で暦上存在する日付でご入力ください',

};
